import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const beauticianSlice = createApi({
    reducerPath: "beauticianSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getBeauticians: builder.query({
            query: ({ page = 1, limit = 10, search = "", type = "all", cityId = "" }) => ({
                url: `/beautician/list?page=${page}&limit=${limit}&search=${search}&type=${type}&cityId=${cityId}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        sendOtpToBeautician: builder.mutation({
            query: (body) => ({
                url: "/beautician/sendOtp",
                method: "POST",
                body,
            }),
        }),

        registerBeautician: builder.mutation({
            query: (body) => ({
                url: "/beautician/register",
                method: "POST",
                body,
            }),
        }),

        uploadBeauticianDoc: builder.mutation({
            query: ({ body, id }) => ({
                url: `/beautician/${id}/documents`,
                method: "POST",
                body,
            }),
        }),

        linkCategory: builder.mutation({
            query: (body) => ({
                url: `/beautician/service_linked`,
                method: "POST",
                body,
            }),
        }),

        linkLocation: builder.mutation({
            query: (body) => ({
                url: `/beautician/user-area-link`,
                method: "POST",
                body,
            }),
        }),

        getAllBeauticianSlots: builder.query({
            query: (id) => ({
                url: `/userTimeSlot/user/${id}`,
                method: "GET",
            }),
        }),

        addBeauticianSlots: builder.mutation({
            query: (body) => ({
                url: `/userTimeSlot`,
                method: "POST",
                body,
            }),
        }),

        updateBeauticianSlots: builder.mutation({
            query: ({ id, body }) => ({
                url: `/userTimeSlot/${id}`,
                method: "PUT",
                body,
            }),
        }),

        getSingleBeautician: builder.query({
            query: (id) => ({
                url: `/beautician/singleDetail/${id}`,
                method: "GET",
            }),
        }),

        deleteBeautician: builder.mutation({
            query: (id) => ({
                url: `/beautician/beautician/${id}`,
                method: "DELETE",
            }),
        }),

        fetchBeauticians: builder.mutation({
            query: ({ orderId, latitude, longitude, bookingDate, startTime, endTime }) => ({
                url: `/beautician/find_beautician`,
                method: "POST",
                body: { orderId, latitude, longitude, bookingDate, startTime, endTime },
            }),
        }),

        assignBeauticians: builder.mutation({
            query: (formData) => ({
                url: `/beautician/assign`,
                method: "POST",
                body: formData,
            }),
        }),

        unlinkArea: builder.mutation({
            query: (id) => ({
                url: `/beautician/user-area-unlink/${id}`,
                method: "DELETE",
            }),
        }),
        beauticianStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/beautician/update-status`,
                method: "POST",
                body: { status, userId: id }
            }),
        }),
        beauticianDetials: builder.mutation({
            query: ({ beauticanId, status, page = 1, limit = 10, search = "" }) => ({
                url: `/setting/get-beatican-details`,
                method: "POST",
                body: { beauticanId, status, page, limit, search },
            }),
        }),
        userBookingDetails: builder.mutation({
            query: ({ userId, status, orderType, search = "", page = 1, limit = 10, }) => ({
                url: `/setting/get-user-booking-details`,
                method: "POST",
                body: { userId, status, orderType, search, page, limit }
            })
        }),
        beauticanEarningDeatils: builder.mutation({
            query: ({ beauticianId, search, page = 1, limit = 10 }) => ({
                url: `/setting/get-beautician-earning`,
                method: "POST",
                body: { beauticianId, search, page, limit }
            })
        }),
        UpdateBookingStatus: builder.mutation({
            query: ({ id, type, status }) => ({
                url: `/setting/update-booking-status`,
                method: "POST",
                body: { id, type, status }
            })
        }),
        assisgnPlan: builder.mutation({
            query: (body) => ({
                url: `/subscription/subscribe`,
                method: "POST",
                body,
            }),
        }),
        submitCart: builder.mutation({
            query: (id) => ({
                url: `/beautician/place-pay-after`,
                method: "POST",
                body: { userId: id },
            }),
        }),

        getSpecializations: builder.query({
            query: () => ({ url: `/beautician/specializations`, method: "GET" }),
            transformResponse: (response) => response.data,
        }),

        updateBeauticianOverview: builder.mutation({
            query: ({ id, bio, specializations }) => ({
                url: `/beautician/overview/${id}`,
                method: "PUT",
                body: { bio, specializations },
            }),
        }),

        getBeauticianWalletBalance: builder.query({
            query: (userId) => ({ url: `/beautician/balance/${userId}`, method: "GET" }),
            transformResponse: (response) => response.data,
        }),

        getBeauticianTransactions: builder.query({
            query: ({ userId, page = 1, limit = 10 }) => ({
                url: `/beautician/transaction/${userId}?page=${page}&limit=${limit}`,
                method: "GET",
            }),
            transformResponse: (response) => response.data,
        }),

        addBeauticianFunds: builder.mutation({
            query: ({ userId, amount, description }) => ({
                url: `/beautician/add-funds/${userId}`,
                method: "POST",
                body: { amount, description },
            }),
        }),

    }),
});

export const {
    useBeauticianDetialsMutation,
    useUserBookingDetailsMutation,
    useBeauticanEarningDeatilsMutation,
    useUpdateBookingStatusMutation,
    useGetBeauticiansQuery,
    useSendOtpToBeauticianMutation,
    useRegisterBeauticianMutation,
    useUploadBeauticianDocMutation,
    useLinkCategoryMutation,
    useLinkLocationMutation,
    useGetAllBeauticianSlotsQuery,
    useAddBeauticianSlotsMutation,
    useUpdateBeauticianSlotsMutation,
    useGetSingleBeauticianQuery,
    useDeleteBeauticianMutation,
    useFetchBeauticiansMutation,
    useAssignBeauticiansMutation,
    useUnlinkAreaMutation,
    useBeauticianStatusMutation,
    useAssisgnPlanMutation,
    useSubmitCartMutation,
    useGetSpecializationsQuery,
    useUpdateBeauticianOverviewMutation,
    useGetBeauticianWalletBalanceQuery,
    useGetBeauticianTransactionsQuery,
    useAddBeauticianFundsMutation,
} = beauticianSlice;